// Apolo IDE — turn-abort beacon no unload (auditoria 2026-07-02).
//
// Reload/fechar o app no meio de um turno matava o loop no renderer, mas o
// servidor nunca via o `turn_end` → deriveSessionStatus mantinha a sessão
// "running" por até 10min (STALE_RUN_MS). Aqui, no `pagehide`, disparamos
// turn-abort para CADA sessão viva, reconciliando o status na hora.
//
// Por que fetch keepalive e não sendBeacon: o endpoint exige `Authorization:
// Bearer`, e sendBeacon não seta headers. `fetch(..., { keepalive:true })` seta
// o header E sobrevive ao unload da página. Lógica pura (fetch/token/url
// injetáveis) pra ser unit-testável.

import { apiUrl } from './apiBase.js';
import { getStoredToken } from './api.js';
import { externallyOwnedSessions } from './runtime/supervisorBridge.js';
import { listRunning } from './agentRunStore.js';

/**
 * Dispara turn-abort (keepalive) para cada sessão em `running`. Retorna quantos
 * beacons foram enviados. Best-effort — nunca lança.
 */
export function flushRunningAborts({
  running = [],
  token = null,
  fetchImpl = (typeof fetch !== 'undefined' ? fetch : null),
  urlFor = (id) => apiUrl(`/api/code-ide/sessions/${id}/turn-abort`),
} = {}) {
  if (!fetchImpl || !running.length) return 0;
  let sent = 0;
  for (const id of running) {
    if (!id) continue;
    try {
      fetchImpl(urlFor(id), {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        keepalive: true,
      });
      sent += 1;
    } catch {
      /* best-effort — unload não pode travar */
    }
  }
  return sent;
}

/** Wiring de conveniência: coleta as sessões vivas + token e faz o flush. */
export function flushRunningAbortsNow() {
  return flushRunningAborts({ running: listRunning().filter((id) => !externallyOwnedSessions().includes(id)), token: getStoredToken() });
}
